export var PAGE_NOT_FOUND_ROUTE = 'page-not-found';
export var rootNamespace = 'root';
export var EXTERNAL_FRAMEWORKS = {
    angular: 'angular',
    vue: 'vue',
    react: 'react',
};
